import { Component, OnDestroy, OnInit } from '@angular/core';
import {MenuItem} from 'primeng/api';
import {ActivatedRoute, Router} from '@angular/router';
import {Device} from '../../../model/device';
import {DevicesService} from '../../../services/devices.service';
import { translate, TranslocoService } from '@ngneat/transloco';
import {SharedResource} from '../../../model/shared-resource';
import { take } from 'rxjs/operators';
import {AuthGuard} from '../../../common/auth-guard.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-devices-details',
  templateUrl: './devices-details.component.html',
  styleUrls: ['./devices-details.component.scss']
})
export class DevicesDetailsComponent implements OnInit, OnDestroy {

  public navState: any;

  public device: Device;

  public items: MenuItem[];
  public activeItem: MenuItem;
  public activeItemIndex: number;

  public sharedResources: Array<SharedResource> = [];
  public showDialog = false;

  private paramsSubscription: Subscription;
  private queryParamsSubscription: Subscription;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private devicesService: DevicesService,
              private translocoService: TranslocoService,
              private authGuard: AuthGuard) {
    const navigation = this.router.getCurrentNavigation();
    this.navState = navigation?.extras.state;
  }

  ngOnInit(): void {
    this.paramsSubscription = this.route.params.subscribe(params => this.loadDevice(params.uuid));

    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      this.navState = { showView: params.showView };
    });

    this.translocoService.selectTranslate('common.new').pipe(take(1)).subscribe(() => {

      this.items = [
        {id: 'overview', label: translate('common.overview'), icon: 'pi pi-home'},
        {id: 'sensors', label: translate('model.sensors'), icon: 'pi pi-wifi'},
        {id: 'measures', label: translate('model.measures'), icon: 'pi pi-chart-bar'},
        {id: 'triggers', label: translate('model.triggers'), icon: 'pi pi-exclamation-triangle'},
        {id: 'events', label: translate('model.events'), icon: 'pi pi-exclamation-circle'},
        {id: 'technicalDetails', label: translate('attribute.technicalDetails'), icon: 'pi pi-file'},
        {id: 'integrationModules', label: translate('model.integrationModules'), icon: 'pi pi-table'},
      ];
      if(this.authGuard.operatorRequired()){
        this.items.push({id: 'commands', label: translate('model.commands'), icon: 'pi pi-code'});
      }

      if (this.authGuard.superAdminRequired()) {
        this.items.push({id: 'nettopo', label: translate('menu.nettopo'), icon: 'pi pi-globe'});
        this.items.push({id: 'diagnosis', label: translate('menu.diagnosis'), icon: 'pi pi-heart'});
      }

      if (this.navState && this.navState.showView) {
        this.activeItemIndex = this.items.indexOf(this.items.filter(item => item.id === this.navState.showView)[0]);
        this.activeItem = this.items[this.activeItemIndex];
      } else {
        this.activeItemIndex = 0;
        this.activeItem = this.items[this.activeItemIndex];
      }

    });
  }

  loadDevice(deviceUuid: string): void {
    this.devicesService.getDevice(deviceUuid).subscribe(response => {
      this.device = response.device;
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['/not-found']);
      }
    });
  }

  showSharedDialog(sharedResource: Device): void {
    this.sharedResources = [new SharedResource('DEVICE', sharedResource.serialNumber, sharedResource.uuid,
      sharedResource.tenant.uuid, sharedResource.organization.uuid)];
    this.showDialog = true;
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
    this.activeItemIndex = this.items.indexOf(this.activeItem);
  }

  ngOnDestroy(): void {
    this.paramsSubscription.unsubscribe();
    this.queryParamsSubscription.unsubscribe();
  }

}
